import { useEffect } from 'react'

export const useHideChatlio = () => {
  // Hide Chatlio on meeting page
  useEffect(() => {
    const hideChatlio = () => {
      // Hide the chatlio widget - check if it exists first
      if (typeof window !== 'undefined' && window._chatlio) {
        const chatlio = window._chatlio
        if (chatlio.hide && typeof chatlio.hide === 'function') {
          chatlio.hide()
        }
      }

      // Hide the custom chatlio button
      const chatlioButton = document.getElementById('chatlio-widget-button')
      if (chatlioButton) {
        chatlioButton.style.display = 'none'
      }

      // Also hide the actual chatlio widget element
      const chatlioWidget = document.querySelector('chatlio-widget')
      if (chatlioWidget) {
        (chatlioWidget as HTMLElement).style.display = 'none'
      }
    }

    const showChatlio = () => {
      // Show the chatlio widget - check if it exists first
      if (typeof window !== 'undefined' && window._chatlio) {
        const chatlio = window._chatlio
        if (chatlio.show && typeof chatlio.show === 'function') {
          chatlio.show()
        }
      }

      // Show the custom chatlio button
      const chatlioButton = document.getElementById('chatlio-widget-button')
      if (chatlioButton) {
        chatlioButton.style.display = 'flex'
      }

      // Show the actual chatlio widget element
      const chatlioWidget = document.querySelector('chatlio-widget')
      if (chatlioWidget) {
        (chatlioWidget as HTMLElement).style.display = 'block'
      }
    }

    // Try to hide immediately if elements are already loaded
    hideChatlio()

    // Also listen for chatlio ready event in case it's not loaded yet
    const handleChatlioReady = () => {
      hideChatlio()
    }

    // Use a small delay to ensure DOM is ready
    const timeoutId = setTimeout(hideChatlio, 100)

    document.addEventListener('chatlio.ready', handleChatlioReady)

    return () => {
      clearTimeout(timeoutId)
      document.removeEventListener('chatlio.ready', handleChatlioReady)
      showChatlio()
    }
  }, [])

  return {}
}
